import React from 'react';
import Image from './Image';
import Heading from './Heading';
import Carousel from './Carousel';
import './styles.scss';

interface Props {
  backgroundImage: string;
  mobilebackgroundImage: string;
  images: any;
  title: string;
  mobiletitle: string;
  description: string;
  overlay_slides: string;
  slides_shapes: string;
  slides_to_show: string;
  banner_top_shadow: string;
  banner_top_shadow_opacity: string;
  banner_bottom_shadow: string;
  banner_bottom_shadow_opacity: string;
  paragraphId:string;
  sub_heading:string;
  title_font_color:string;
  imageCarouselBackgroundColor:string;
  imageCarouselMarginTop:string;
  imageCarouselMarginBottom:string;
  imageCarouselTopSize:string;
  imageCarouselTopColor:string;
  imageCarouselBottomSize:string;
  imageCarouselBottomColor:string;
  imageCarouselLeftSize:string;
  imageCarouselLeftColor:string;
  imageCarouselRightSize:string;
  imageCarouselRightColor:string;
}

const PromoUnits: React.FC<Props> = ({ backgroundImage, mobilebackgroundImage, images, title, mobiletitle, description, overlay_slides,slides_to_show, banner_top_shadow, banner_top_shadow_opacity, banner_bottom_shadow, banner_bottom_shadow_opacity, slides_shapes,paragraphId, sub_heading, title_font_color, imageCarouselBackgroundColor,imageCarouselMarginTop, imageCarouselMarginBottom, imageCarouselTopSize, imageCarouselTopColor, imageCarouselBottomSize, imageCarouselBottomColor, imageCarouselLeftSize, imageCarouselLeftColor, imageCarouselRightSize, imageCarouselRightColor}) => {

  return (
    <>
      {
        <style
          dangerouslySetInnerHTML={{
            __html: `
            .paragraph--type--slider-with-big-banner { ` +
            (imageCarouselBackgroundColor ? ` background-color: ` + imageCarouselBackgroundColor + `; ` : '' ) +
            (imageCarouselMarginTop ? ` margin-top: ` + imageCarouselMarginTop + `rem; ` : '' ) +
            (imageCarouselMarginBottom ? ` margin-bottom: ` + imageCarouselMarginBottom + `rem; ` : '' ) +
            ((imageCarouselTopSize && imageCarouselTopColor) ? `border-top: `+imageCarouselTopSize+`rem solid `+imageCarouselTopColor+` !important;` : '' ) +
            ((imageCarouselBottomSize && imageCarouselBottomColor) ? `border-bottom: `+imageCarouselBottomSize+`rem solid `+imageCarouselBottomColor+` !important;` : '' ) +
            ((imageCarouselLeftSize && imageCarouselLeftColor) ? `border-left: `+imageCarouselLeftSize+`rem solid `+imageCarouselLeftColor+` !important;` : '' ) +
            ((imageCarouselRightSize && imageCarouselRightColor) ? `border-right: `+imageCarouselRightSize+`rem solid `+imageCarouselRightColor+` !important;` : '' )
            + `}

             .paragraph--type--slider-with-big-banner .card-heading .card-header { ` +
            (imageCarouselBackgroundColor ? ` background-color: ` + imageCarouselBackgroundColor + ` !important; border: none !important; ` : '' ) + `}`
          }}
        />
      }

    <section className={"paragraph paragraph--type--slider-with-big-banner bottom-slides bottom-fade "+overlay_slides+" "+slides_shapes} >
      {backgroundImage ?
        <Image backgroundImage={backgroundImage} mobilebackgroundImage={mobilebackgroundImage} title={title} mobiletitle={mobiletitle} description={description} banner_top_shadow={banner_top_shadow} banner_top_shadow_opacity={banner_top_shadow_opacity} banner_bottom_shadow={banner_bottom_shadow}  banner_bottom_shadow_opacity={banner_bottom_shadow_opacity} slides_shapes={slides_shapes} slides_to_show={slides_to_show} paragraphId={paragraphId} sub_heading={sub_heading} />
        : title
          ? <Heading title={title} mobiletitle={mobiletitle} description={description} banner_top_shadow={banner_top_shadow} banner_top_shadow_opacity={banner_top_shadow_opacity} banner_bottom_shadow={banner_bottom_shadow}  banner_bottom_shadow_opacity={banner_bottom_shadow_opacity} slides_shapes={slides_shapes} slides_to_show={slides_to_show} paragraphId={paragraphId} sub_heading={sub_heading} title_font_color={title_font_color} />
          : ""
      }
      <Carousel images={images} slides_to_show={slides_to_show} slideShapes={slides_shapes} paragraphId={paragraphId} banner_top_shadow={banner_top_shadow} banner_top_shadow_opacity={banner_top_shadow_opacity} banner_bottom_shadow={banner_bottom_shadow} banner_bottom_shadow_opacity={banner_bottom_shadow_opacity} />
    </section>
    </>
  );
};

export default PromoUnits;
